import * as React from 'react'

import { Modal } from './Modal'

export class SuccessModal extends React.Component<
  { title: string; children?: React.ReactNode; asModal?: boolean },
  {}
> {
  render() {
    const { ...props } = this.props
    return <Modal {...props} variant={'default'} />
  }
}
